export function initialAgentState() {
    return { text: "", status: "queued", suggestions: [], sources: [], tasks: {} };
}
export function activityTranslationKey(state) {
    if (!["queued", "running"].includes(state.status))
        return undefined;
    const keys = {
        "products.searching": "chat.activityProducts",
        "products.checking": "chat.activityProductDetails", "products.reviewing": "chat.activityProductReview",
        "knowledge.searching": "chat.activityKnowledge", search_products: "chat.activityProducts",
        present_products: "chat.activityProductReview", search_knowledge: "chat.activityKnowledge",
        search_website: "chat.activityKnowledge", check_availability: "chat.activityAvailability",
        create_booking: "chat.activityBooking", read_booking: "chat.activityAvailability",
        save_customer: "chat.activitySaving", save_task_data: "chat.activitySaving",
        save_support_issue: "chat.activitySaving", update_support: "chat.activitySaving",
        start_task: "chat.activitySaving", close_task: "chat.activitySaving",
        deliver_task: "chat.activitySending", request_human: "chat.activityHandoff", activate_human: "chat.activityHandoff",
        support_playbooks: "chat.activitySupport", support_steps: "chat.activitySupport",
    };
    return keys[state.activity || ""];
}
export function reduceAgentEvent(state, event) {
    const payload = event.payload;
    switch (event.type) {
        case "run.queued": return { ...state, status: "queued", error: undefined };
        case "run.started": return { ...state, status: "running", error: undefined };
        case "text.delta": return { ...state, text: state.text + (payload.text || ""), messageId: payload.message_id,
            ...(payload.text ? { activity: undefined, activityGoal: undefined } : {}) };
        case "text.completed": return { ...state, text: payload.text || "", messageId: payload.message_id,
            activity: undefined, activityGoal: undefined };
        case "products.results": return { ...state, products: payload };
        case "booking.slots": return { ...state, calendar: payload, bookingTaskId: payload.task_id };
        case "booking.confirmed": return { ...state, booking: payload, calendar: undefined };
        case "booking.simulated": return { ...state, calendar: undefined };
        case "knowledge.results": return { ...state, sources: [...new Set([...state.sources, ...(payload.sources || [])])] };
        case "suggestions.updated": return { ...state, suggestions: Array.isArray(payload.suggestions) ? payload.suggestions : [] };
        case "task.updated": return { ...state, tasks: { ...state.tasks, [payload.task_id]: payload } };
        case "customer.updated": return { ...state, customer: payload };
        case "support.updated": return { ...state, support: payload };
        case "delivery.updated": return { ...state, delivery: payload };
        case "handoff.updated": return { ...state, handoff: payload };
        case "agent.activity": return { ...state, activity: payload.stage, activityGoal: typeof payload.goal === "string" ? payload.goal.slice(0, 80) : undefined };
        case "tool.activity": return { ...state, activity: payload.status === "started" ? payload.tool : undefined, activityGoal: undefined };
        case "run.completed": return { ...state, status: "completed", activity: undefined, activityGoal: undefined };
        case "run.failed": return { ...state, status: "failed", activity: undefined, activityGoal: undefined, error: payload.code };
        case "run.interrupted": return { ...state, status: "interrupted", activity: undefined, activityGoal: undefined };
        default: return state;
    }
}
/** WS replay can interleave with broadcasts; apply each sequence exactly once and in order. */
export class OrderedEvents {
    constructor(runId, accept, after = 0) {
        this.runId = runId;
        this.accept = accept;
        this.cursor = 0;
        this.pending = new Map();
        this.cursor = after;
    }
    get hasGap() { return this.pending.size > 0; }
    push(candidate) {
        const event = candidate;
        if ((event === null || event === void 0 ? void 0 : event.version) !== 2 || event.run_id !== this.runId || !Number.isInteger(event.seq) || event.seq <= this.cursor || !event.payload)
            return;
        this.pending.set(event.seq, event);
        while (this.pending.has(this.cursor + 1)) {
            const next = this.pending.get(++this.cursor);
            this.pending.delete(this.cursor);
            this.accept(next);
        }
    }
}
